// extracted by mini-css-extract-plugin
module.exports = {"cart-icon":"bq_d6","cartIcon":"bq_d6","badge":"bq_d7"};